import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    applications: {
        page: 1,
        hasMore: true,
        list: [],
        total: 0
    },
    modules: {
        page: 1,
        hasMore: true,
        list: [],
        total: 0
    },
    environments: {
        page: 1,
        hasMore: true,
        list: [],
        total: 0
    },
    skillStreams: {
        page: 1,
        hasMore: true,
        list: [],
        total: 0
    }
}

const assignedSlice = createSlice({
    name: "assignedSlice",
    initialState,
    reducers: {
        saveApplications: (state, action) => {
            state.applications = action.payload.data;
        },
        saveModules: (state, action) => {
            state.modules = action.payload.data;
        },
        saveEnvironments: (state, action) => {
            state.environments = action.payload.data;
        },
        saveSkillStreams: (state, action) => {
            state.skillStreams = action.payload.data;
        },
    },

});

export const { saveApplications, saveModules, saveEnvironments, saveSkillStreams } = assignedSlice.actions;
export default assignedSlice.reducer;